import { Background } from './Background'
import { Footer } from './Footer'
import { Menu } from './Menu'

export const Component = { Menu, Footer, Background }
